import { render, staticRenderFns } from "./Leaf.vue?vue&type=template&id=2b41fa16&scoped=true"
import script from "./Leaf.vue?vue&type=script&lang=js"
export * from "./Leaf.vue?vue&type=script&lang=js"
import style0 from "./Leaf.vue?vue&type=style&index=0&id=2b41fa16&prod&lang=less&scoped=true"
import style1 from "./Leaf.vue?vue&type=style&index=1&id=2b41fa16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41fa16",
  null
  
)

export default component.exports